import random from 'lodash/random';

// 定时器随机打散函数，用于防止倒计时结束后多个请求同时打到服务器，qps升高问题
export const setTimeoutRandom = (fn, num = 2000) => {
    const time = random(num);
    setTimeout(() => {
        fn();
    }, time);
};
